import styled from 'styled-components'

export const EventsContainer = styled.div`
  margin-top: 16px;
`
